<template>
  <section class="colaboradores">
    <header>
      <h4>Resultado de Busca</h4>
      <p v-if="colaboradores">Sua busca retornou {{ colaboradores.length }} {{ colaboradores.length == 1 ? 'colaborador' : 'colaboradores'  }}</p>
    </header>
    <div>
      <table class="transparent-table" v-if="colaboradores">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th>Função</th>
            <th>Área</th>
            <th>Departamento</th>
            <th>Unidade</th>
            <th>Situação</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="colaborador in colaboradores" :key="colaborador.idColaborador">
            <td>{{ colaborador.idColaborador }}</td>
            <td>{{ colaborador.nome_pessoa }}</td>
            <td>{{ colaborador.nome_funcao }}</td>
            <td>{{ colaborador.nome_setor }}</td>
            <td>{{ colaborador.departamento }}</td>
            <td>{{ colaborador.nome_unidade }}</td>
            <td><span v-if="colaborador.nome_situacao" :class="['marker', colaborador.nome_situacao.toLowerCase()]">{{ colaborador.nome_situacao }}</span></td>
            <td class="actions">
              <button
                v-if="colaborador.possuiAcessoPlurall"
                type="button"
                class="btn btn-secondary plurall-reset-button"
                :disabled="isResetting(colaborador.idColaborador)"
                :aria-busy="isResetting(colaborador.idColaborador) ? 'true' : 'false'"
                @click="resetPlurallPassword(colaborador)"
              >
                {{ isResetting(colaborador.idColaborador) ? 'Redefinindo...' : 'Resetar senha Plurall' }}
              </button>
              <router-link
                class="edit-link"
                :aria-label="`Editar colaborador ${colaborador.nome_pessoa}`"
                :to="{ name: 'colaboradores', params: { action: 'ver', id: colaborador.idColaborador } }"
              >
                <fa :icon="['fal','pencil']" />
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import AdmService from '@/services/adm.service'

export default {
  props: {
    scope: {
      type: Array
    }
  },
  watch: {
    scope ( value ) {
      if ( value ) this.colaboradores = Object.assign([], value)
    }
  },
  data () {
    return {
      colaboradores: null,
      plurallResetting: {}
    }
  },
  mounted () {
    this.colaboradores = Object.assign([], this.scope)
  },
  methods: {
    isResetting (idColaborador) {
      return Boolean(this.plurallResetting[idColaborador])
    },
    async resetPlurallPassword (colaborador) {
      const confirmed = window.confirm(
        `Redefinir a senha de ${colaborador.nome_pessoa} no Plurall? O acesso atual deixará de funcionar.`
      )
      if (!confirmed || this.isResetting(colaborador.idColaborador)) return

      this.$set(this.plurallResetting, colaborador.idColaborador, true)
      try {
        const response = await AdmService.resetPlurallPassword(colaborador.idColaborador)
        await this.waitForPlurallReset(response.data.documentId)
        window.toaster.emit('open', {
          style: 'success',
          message: `Senha de ${colaborador.nome_pessoa} redefinida no Plurall.`,
          floater: true
        })
      } catch (error) {
        window.toaster.emit('open', {
          style: error.pending ? 'warning' : 'error',
          message: error.response?.data?.message || error.message || 'Não foi possível redefinir a senha no Plurall.',
          floater: true
        })
      } finally {
        this.$delete(this.plurallResetting, colaborador.idColaborador)
      }
    },
    async waitForPlurallReset (documentId) {
      const successful = ['success', 'succeeded', 'completed', 'processed', 'done']
      const failed = ['error', 'failed', 'rejected']

      for (let attempt = 0; attempt < 20; attempt += 1) {
        const response = await AdmService.getPlurallPasswordResetStatus(documentId)
        const status = String(response.data.status || '').toLowerCase()
        if (successful.includes(status)) return
        if (failed.includes(status)) {
          const providerMessage = response.data.logs?.find(log => log.message)?.message
          throw new Error(providerMessage || 'O Plurall rejeitou a redefinição da senha.')
        }
        await new Promise(resolve => window.setTimeout(resolve, 1500))
      }

      const pendingError = new Error('A solicitação foi enviada, mas o Plurall ainda não concluiu o processamento.')
      pendingError.pending = true
      throw pendingError
    }
  }
}
</script>

<style lang="scss" scopes>
  .colaboradores {
    padding: $hmg_mid
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: $mg_mini;
    font-size: 16px;
    padding: $mg_mini !important;
  }

  .plurall-reset-button {
    min-height: 40px;
    white-space: nowrap;
  }

  .edit-link {
    display: inline-flex;
    min-width: 40px;
    min-height: 40px;
    align-items: center;
    justify-content: center;
  }
</style>
